"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Accordion component is used to display a dropdown with title and content. Uses Accordion, AccordionSummary and AccordionDetails from @ori-ui/mui.
 */
const Accordion = ({
  id,
  title,
  content,
  textContent,
  accordionProps,
  accordionSummaryProps,
  accordionDetailsProps
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!title) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AccordionComponent, {
    "data-testid": getTestId(`${_constants.ACCORDION}-${id}`),
    ...accordionProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AccordionSummary, {
      "data-testid": getTestId(`${_constants.ACCORDION_SUMMARY}-${id}`),
      expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {}),
      ...accordionSummaryProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        component: "h6",
        variant: "h6",
        children: title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AccordionDetails, {
      ...accordionDetailsProps,
      children: textContent ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        children: textContent
      }) : content
    })]
  });
};
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map